export default function MintClosed() {
    return (
        <>
            <h2>Unfortunately the mint is now closed</h2>
            <p>If you'd like to purchase an existing AI Haiku, please do so on <a href='https://opensea.io/collection/ai-haiku' target="_blank" rel="noreferrer" style={{ fontSize: 'large'}}>OpenSea</a></p>
        </>
    )
}